import { NavLink } from 'react-router-dom'
import { Home, BarChart2, Settings, LogOut } from 'lucide-react'
import { useAuth } from '../../lib/auth'

export default function Sidebar() {
  const { session, signOut } = useAuth()
  const email = session?.user?.email || ''
  const initials = email ? email.slice(0, 2).toUpperCase() : '?'
  const link = ({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="sidebar-logo-text">Property Press</div>
        <div className="sidebar-logo-sub">Property Manager</div>
      </div>

      <nav className="sidebar-nav">
        <div className="sidebar-section-label">Navigation</div>
        <NavLink to="/" end className={link}><Home size={15} /> Properties</NavLink>
        <NavLink to="/status" className={link}><BarChart2 size={15} /> Status Board</NavLink>
      </nav>

      <div className="sidebar-bottom">
        <div className="sidebar-section-label">System</div>
        <NavLink to="/settings" className={link}><Settings size={15} /> Settings</NavLink>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 20px 16px', marginTop: 4 }}>
          <div style={{
            width: 28, height: 28, borderRadius: '50%',
            background: 'rgba(223,228,86,.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '.65rem', fontWeight: 600, color: 'var(--chartreuse)', flexShrink: 0,
          }}>{initials}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '.72rem', color: 'rgba(255,255,255,.5)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {email}
            </div>
          </div>
          <button onClick={signOut} title="Sign out"
            style={{ color: 'rgba(255,255,255,.35)', display: 'flex', padding: 4, borderRadius: 6, transition: 'color .15s', flexShrink: 0 }}
            onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,.8)'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,.35)'}>
            <LogOut size={14} />
          </button>
        </div>
      </div>
    </aside>
  )
}
